import { KeyboardDoubleArrowDown } from '@mui/icons-material';
import { Stack } from '@mui/material';
import React from 'react';

const Title = ({ title }) => {
  return (
    <React.Fragment>
      <Stack alignItems="center">
        <h3 style={{ marginBottom: '1em', marginTop: 0 }}>
          {title}
        </h3>
        <KeyboardDoubleArrowDown />
      </Stack>
    </React.Fragment>
  );
};

export default Title;
